import type { ComponentType, HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

import type { TextProps } from '@awazevr/design-system.components.text'
import { Text } from '@awazevr/design-system.components.text'

type StylableTextProps = TextProps & HTMLAttributes<HTMLBaseElement>

const StylableText = Text as unknown as ComponentType<StylableTextProps>

const clampedTextStyles = css`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledPropertyType = styled(StylableText)`
  font-weight: bold;
`

export const StyledPropertyLocation = styled(StylableText)`
  ${clampedTextStyles}
  font-weight: bold;
  margin: 0;
`

export const StyledPropertyName = styled(StylableText)`
  ${clampedTextStyles}
`
